module.exports = __webpack_public_path__ + "img/geotechnical.d01b2228.jpg";